import type { ParticipantId } from "../types/common";
import type { Participant } from "../types/game-state";

export function getOpponentId(
  participants: readonly [Participant, Participant],
  participantId: ParticipantId,
): ParticipantId {
  const [first, second] = participants;

  if (first.id === participantId) {
    return second.id;
  }

  if (second.id === participantId) {
    return first.id;
  }

  throw new Error(`Unknown participant id: ${participantId}`);
}
